// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fcsIz","container__table":"styles_container__table__A9nw0"};